export const isBuildPage = (url = '') => {
  const configutaorPageRegex = /build\.html.*[?&]ulid=\d+/;
  const isNewConfiguratorPageRegex = configutaorPageRegex.test(url);
  const hasModels = url.includes('/models/');
  const hasOverviewBuild = url.includes('/overview/build');
  return isNewConfiguratorPageRegex || (hasModels && hasOverviewBuild);
};
